const DEAL_TYPE_ID = 1;

export const createRequestBodyAdapter = (requestBody) => {
  return {
    dealItems: (requestBody.dealItems || []).map((dealItem) => {
      const res = {
        name: dealItem.item?.name || dealItem?.name,
        quantity: dealItem?.quantity,
      };
      if (dealItem.item?.wimsId || dealItem?.wimsId) {
        res.wimsId = dealItem.item?.wimsId || dealItem?.wimsId;
      }
      if (dealItem.item?.wimsModule || dealItem?.wimsModule) {
        res.wimsModule = dealItem.item?.wimsModule || dealItem?.wimsModule;
      }
      return res;
    }),
    comment: requestBody?.comment,
    staffComment: requestBody?.staffComment,
    urgent: requestBody?.urgent,
    customer: requestBody?.customer ? '/api/customers/' + requestBody.customer : undefined,
    project: requestBody?.project?.toString(),
    status: requestBody?.status?.toString(),
    type: requestBody.type || DEAL_TYPE_ID.toString(),
  };
};

export const createCustomerBodyAdapter = (requestBody) => {
  return {
    ...requestBody,
    name: requestBody.name,
  };
};
